"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var AggregateStatusReporter = /*#__PURE__*/function () {
  function AggregateStatusReporter() {
    _classCallCheck(this, AggregateStatusReporter);
    this.callbacks = new Set();
  }
  _createClass(AggregateStatusReporter, [{
    key: "addCallback",
    value: function addCallback() {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
      this.callbacks.add(callback);
      callback(this.currentMessage);
    }
  }, {
    key: "callback",
    value: function callback(message) {
      this.currentMessage = message;
      this.callbacks.forEach(function (elt) {
        elt(message);
      });
    }
  }]);
  return AggregateStatusReporter;
}();
exports.default = AggregateStatusReporter;